import React from 'react';

export const WarningIcon = () => (
  <svg style={{ top: '2px' }} className="warning-icon relative mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1477_57225)">
      <path d="M7.99992 5.33329V7.99996M7.99992 10.6666H8.00659M14.6666 7.99996C14.6666 4.31806 11.6818 1.33329 7.99992 1.33329C4.31802 1.33329 1.33325 4.31806 1.33325 7.99996C1.33325 11.6819 4.31802 14.6666 7.99992 14.6666C11.6818 14.6666 14.6666 11.6819 14.6666 7.99996Z" stroke="#B71E49" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1477_57225">
        <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0 16)" />
      </clipPath>
    </defs>
  </svg>
);
